/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OrganizationUserSessionIssuerReference,
  OrganizationUserSessionIssuerReference$inboundSchema,
} from "./organizationusersessionissuerreference.js";

/**
 * Authoritative impact summary for deleting an organization-owned user_session_issuer.
 */
export type OrganizationUserSessionIssuerDeletePreflight = {
  /**
   * True when no live MCP server, toolset, or active identity-chaining binding references the issuer.
   */
  canDelete: boolean;
  /**
   * Number of non-deleted user_session_clients registered with the issuer.
   */
  clientCount: number;
  /**
   * Active identity-chaining bindings that must be explicitly unlinked before deletion.
   */
  emaBindingCount: number;
  /**
   * Number of non-deleted, unexpired user_sessions issued by the issuer.
   */
  liveSessionCount: number;
  /**
   * Live MCP servers that block deletion.
   */
  mcpServers: Array<OrganizationUserSessionIssuerReference>;
  /**
   * Live toolsets that block deletion.
   */
  toolsets: Array<OrganizationUserSessionIssuerReference>;
  /**
   * True when this is the organization's only organization-level issuer, so deleting it stops serving the organization gateway its members sign in to. Does not block deletion.
   */
  withdrawsOrganizationGateway: boolean;
};

/** @internal */
export const OrganizationUserSessionIssuerDeletePreflight$inboundSchema:
  z.ZodMiniType<OrganizationUserSessionIssuerDeletePreflight, unknown> = z.pipe(
    z.object({
      can_delete: z.boolean(),
      client_count: z.int(),
      ema_binding_count: z.int(),
      live_session_count: z.int(),
      mcp_servers: z.array(
        OrganizationUserSessionIssuerReference$inboundSchema,
      ),
      toolsets: z.array(OrganizationUserSessionIssuerReference$inboundSchema),
      withdraws_organization_gateway: z.boolean(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "can_delete": "canDelete",
        "client_count": "clientCount",
        "ema_binding_count": "emaBindingCount",
        "live_session_count": "liveSessionCount",
        "mcp_servers": "mcpServers",
        "withdraws_organization_gateway": "withdrawsOrganizationGateway",
      });
    }),
  );

export function organizationUserSessionIssuerDeletePreflightFromJSON(
  jsonString: string,
): SafeParseResult<
  OrganizationUserSessionIssuerDeletePreflight,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      OrganizationUserSessionIssuerDeletePreflight$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'OrganizationUserSessionIssuerDeletePreflight' from JSON`,
  );
}
